import styles from "./BulletPoint.module.css";

interface BulletPointProps {
  text: string;
}

function BulletPoint(props: BulletPointProps) {
  if (!props.text) {
    return null;
  }
  return (
    <div className={styles.line}>
      <div className={styles.checkIcon}>
        <span className={`narmi-icon-check ${styles.checkGlyph}`} />
      </div>
      <span className={styles.text}>{props.text}</span>
    </div>
  );
}

export { BulletPoint };
